import { render, staticRenderFns } from "./LabDensityOfWater.vue?vue&type=template&id=46b87f4e&"
import script from "./LabDensityOfWater.vue?vue&type=script&lang=js&"
export * from "./LabDensityOfWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports